import _ from 'lodash';

/**
 * @description The function to edit projects
 * @param {service} Project The Project service
 * @param {Unknown} FormatProject Unknown
 * @param {Unknown} $rootScope Unknown
 * @param {Unknown} $uibModalInstance Unknown
 * @param {resolve} project The resolved project
 * @param {resolve} appointment The resolved appointment
 * @param {Unknown} StyleFactory Unknown
 * @param {service} AlertMessages The alert messages service
 * @param {service} Activity The activity service
 * @param {service} Session The Session service
 * @param {service} Appointment The Appointment service
 * @param {service} Notification The Notification service
 * @param {constant} NOTIFICATIONS The NOTIFICATIONS constant
 * @param {constant} RESPONSE_MESSAGES The RESPONSE_MESSAGES constant
 * @param {constant} STATUS_IDS The STATUS_IDS constant
 * @param {service} Shop The Shop service
 * @param {service} MessageTemplates The MessageTemplates service
 */
function ProjectUpdateController(
  Project,
  FormatProject,
  $rootScope,
  $uibModalInstance,
  project,
  appointment,
  StyleFactory,
  AlertMessages,
  Activity,
  Session,
  Appointment,
  Notification,
  NOTIFICATIONS,
  RESPONSE_MESSAGES,
  STATUS_IDS,
  Shop,
  MessageTemplates
) {
  let vm = this;

  vm.$onInit = function() {
    // Make a copy of the project and currently viewed appointment when the
    // modal controller is loaded
    vm.projectTmp = _.cloneDeep(project);
    vm.projectCompare = _.cloneDeep(project);
    vm.session = Session;
    vm.updatedAppointment;
    vm.returnData = {};

    // Public methods
    vm.saveProject = saveProject;
    vm.cancel = cancel;
    vm.agreeToUpdatePolicy = agreeToUpdatePolicy;

    // Defaults
    // vm.agreedToUpdatePolicy = false;
    vm.canEditProject = false;
    vm.iAgreeToUpdatePolicy = false;
    vm.projectUpdateConfirmedAppt =
    RESPONSE_MESSAGES.projectUpdateConfirmedAppt.message;

    // If a confirmed appointment exists
    if (appointment) {
      vm.appointmentTmp = _.cloneDeep(appointment);
      vm.privacyPolicyIsCollapsed =
      vm.appointmentTmp.agreed_to_cancellation_policy;
    }

    // Get the shop policy if one exists
    if (vm.appointmentTmp && vm.appointmentTmp.shop) {
      Shop.get(vm.appointmentTmp.shop.id).then(function(shop) {
        MessageTemplates.get(shop.message_templates)
        .then(function(messageTemplates) {
          vm.shopMessageTemplates = messageTemplates;
        });
      });
    }

    // Determine the edit project status
    // If role is artist or operator, pass them to the edit form immediately
    if (Session.activeState.role === 'artist' ||
    Session.activeState.role === 'operator') {
      vm.canEditProject = true;

    // If there is no appointment, then freely allow project edits
    } else if (!vm.appointmentTmp) {
      vm.canEditProject = true;

      // If an appointment exists but has been cancelled
    } else if
    (vm.appointmentTmp.last_status.status_id !== STATUS_IDS.confirmed) {
      vm.canEditProject = true;
    }
  };

  // Get Menu Options for Various Dropdowns
  Project.getOptions().then(function(options) {
    vm.options = options;
  });

  // Get Tattoo Styles
  StyleFactory.getStyles().then(function(styles) {
    vm.styles = styles;
  });

  /**
   * @name agreeToUpdatePolicy
   * @description Function to agree to the cancellation and/or project update
   * policy. When the cancellation policy hasn't been agreed to, send an appt
   * update to declare the collector has agreed to the policy.
   */
  function agreeToUpdatePolicy() {
    if (!vm.appointmentTmp.agreed_to_cancellation_policy) {
      vm.appointmentTmp.agreed_to_cancellation_policy =
      vm.iAgreeToUpdatePolicy;
      Appointment.update(vm.appointmentTmp)
      .then(function(updatedAppointment) {
        vm.canEditProject = true;
        vm.returnData.updatedAppointment = updatedAppointment;
      });
    } else {
      vm.canEditProject = true;
    }
  }


  /**
   * @description Save project updates
   * @param {object} project The project to be saved
   */
  function saveProject(project) {
    Project.update(project)
    .then(function(updatedProject) {
      vm.returnData.formattedProject = FormatProject.format(updatedProject);

      // Send project updated email notif if the project has changed and an
      // appt exists and the appt is unconfirmed or confirmed
      if ((!(_.isEqual(vm.projectTmp, vm.projectCompare)) &&
      vm.appointmentTmp &&
      (vm.appointmentTmp.current_status === 40 ||
      vm.appointmentTmp.current_status === 50))) {
        let notification = {
          // Recipients are now managed by the API based on notif prefs
          notificationId: NOTIFICATIONS.projectUpdated,
          messageObjects: {
            appointmentId: vm.appointmentTmp.id,
            projectId: vm.returnData.formattedProject.id,
            // The artist assigned to the appointment
            artistId: vm.appointmentTmp.artist.id,
            // The project collector
            collectorId: vm.returnData.formattedProject.collector.id,
            // The logged in user
            operatorId: Session.collector.id
          },
          messageVariables: {
            subject: 'A project you’re working on was updated'
          }
        };
        Notification.send(notification);
      }
      AlertMessages.add({
        msg: 'We saved your project updates.',
        type: 'success'
      });
      $uibModalInstance.close(vm.returnData);
      vm.projectTmp = {};
    });
  }

/**
 * @description Dismiss the modal instance with a reason of 'Canceled'
 */
  function cancel() {
    if (vm.returnData.updatedAppointment) {
      $uibModalInstance.close(vm.returnData);
    } else {
      $uibModalInstance.dismiss('Canceled');
    }
  }
}

angular
  .module('inkfinder')
  .controller('ProjectUpdateController', ProjectUpdateController);



// WEBPACK FOOTER //
// ./components/projects/project/update/project-update.controller.js